import * as React from 'react';
import { cn } from '../../lib/utils.js';

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn('animate-pulse rounded-[var(--radius-element,var(--radius))] bg-[var(--surface-container-high)]', className)}
      data-astryx-skeleton=""
      {...props}
    />
  );
}

export { Skeleton };
